import React from 'react'
import { useQuery } from 'react-query'
import { Loader } from '@crossfit/ui'

import * as affiliatesService from 'services/affiliates'
import InnerContent from 'components/InnerContent'
import useQueryParams from 'hooks/useQueryParams'
import InvitationForm from './Form'
import InvalidInvitation from './Invalid'
import PageHeader from 'components/PageHeader'
import usePageTitle from 'hooks/usePageTitle'

function useInvitation(affiliateId, token) {
  const invitationQuery = useQuery(['invitation', affiliateId, token], () =>
    affiliatesService.fetchInvitation(affiliateId, token),
  )

  const affiliateQuery = useQuery(['affiliate', affiliateId], () =>
    affiliatesService.fetchAffiliate(affiliateId),
  )

  return {
    isLoading: invitationQuery.isLoading || affiliateQuery.isLoading,
    invitation: invitationQuery.data,
    affiliate: affiliateQuery.data,
    error: invitationQuery.error || affiliateQuery.error,
  }
}

function ReviewInvitePage() {
  usePageTitle('CrossFit Affiliate Toolkit | Review Your Invite')
  const queryParams = useQueryParams()
  const { isLoading, affiliate, invitation } = useInvitation(
    queryParams.get('affiliate_id'),
    queryParams.get('invitation_token'),
  )

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <PageHeader>Review Your Invite</PageHeader>

      <InnerContent variant='large'>
        {invitation ? (
          <InvitationForm affiliate={affiliate} token={invitation.token} />
        ) : (
          <InvalidInvitation />
        )}
      </InnerContent>
    </>
  )
}

export default ReviewInvitePage
